// env.staging.ts
export const stagingEnv = {
  VITE_ENV: 'staging',

  VITE_PLATFORM_REST_ENDPOINT: 'https://platform-api.staging.arcual.art',
  VITE_SERVER_EVENTS_PREFIX: 'https://platform-api.staging.arcual.art',

  VITE_AUTH_TOKEN_KEY: 'auth-token-staging',
  VITE_AUTH0_CLAIMS_NAMESPACE: 'https://arcual-access.com',

  VITE_STOREFRONT_URL: 'staging.arcual.app',
  VITE_PLATFORM_URL: 'https://platform.staging.arcual.app',

  VITE_IMG_PROXY_URL: 'https://cdn.staging.arcual.art',
  VITE_PROFILE_IMG_PROXY_BUCKET: 's3://arcual-access-artwork-pictures-staging',
  VITE_ARTWORK_IMG_PROXY_BUCKET: 's3://arcual-access-artwork-pictures-staging',
  VITE_DOCUMENTS_IMG_PROXY_BUCKET: 's3://arcual-access-artwork-documents-staging',

  VITE_SENTRY_INGEST_URL:
    'https://2fa61f8db733ea49c5eb8fb94374bbbb@o4507137752104960.ingest.de.sentry.io/4507137754595408',

  // Feature flags (TODO: make server side)
  VITE_DIGITAL_DOSSIER_ENABLED: true,
  VITE_FEATURE_EDITIONS_ENABLED: true,
  VITE_FEATURE_UPGRADE_NOTE_ENABLED: true,
  VITE_FEATURE_DASHBOARD_ANALYTICS_ENABLED: true,
  VITE_FEATURE_INVENTORY_ENABLED: true,
  VITE_FEATURE_MARK_AS_SOLD_ENABLED: true,
  VITE_FEATURE_NEW_DASHBOARD_DEFAULT: false,
  VITE_FEATURE_PAYMENT_SETTINGS_DEFAULT: false,
  VITE_FEATURE_ITEM_TRANSFER: false,
  VITE_FEATURE_NOTIFICATIONS_ENABLED: false,
  VITE_FEATURE_TEAM_ENABLED: false,
  VITE_FEATURE_VIEWING_ROOMS: false,
  VITE_FEATURE_SUBSCRIPTION_ENABLED: true,
  VITE_FEATURE_CURRENCY_CONFIGURATION_ENABLE: true,

  VITE_FEATURE_SENTRY_ENABLED: true,
  VITE_FEATURE_SENTRY_CUSTOMER_FEEDBACK_ENABLED: true,

  // TODO remove once price visibility selection is implemented
  VITE_FEATURE_HIDE_PRICE_VISIBILITY_ID: 'f31ed19e-0d6a-4581-bc00-15a15e10f589',

  VITE_FUTURE_FAIR_ACTIVATION_ID: 'cf9965ef-4d0b-4f8c-9031-556d48080050',
  VITE_FUTURE_FAIR_ACTIVATION_ID_2: '7ae1b8c3-28f9-4ab0-b0e1-69c174738711',

  // checkout application
  VITE_CHECKOUT_DOMAIN: 'https://checkout.staging.arcual.app/',
  // TODO: replace with server side request to get the images
  // CORS image request proxy service
  VITE_CORS_PROXY: 'https://ptk2a9accc.execute-api.eu-central-1.amazonaws.com/staging/cors-proxy?url=',
  VITE_AMPLITUDE_CLIENT_KEY: 'client-Nai5u2Bku3NZkMWq1KULYzUIgjttFgHs',
  VITE_USETIFUL_TOKEN: null,
};
